import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	teamLabel: {
		id: 'dynamic-cards-search-page.team',
		defaultMessage: 'Team',
		description: 'Team label text',
	},
	avatarLabel: {
		id: 'dynamic-cards-search-page.avatar',
		defaultMessage: 'Avatar',
		description: 'Avatar label text',
	},
});
